import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m5 9.176 6.137 3.758c.523.32 1.203.32 1.726 0L19 9.175M6.556 17.033h10.888c.86 0 1.556-.64 1.556-1.428V8.462c0-.79-.696-1.429-1.556-1.429H6.556c-.86 0-1.556.64-1.556 1.429v7.143c0 .789.696 1.428 1.556 1.428Z",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };